import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "banner banner-welcome" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-between align-items-start" }
const _hoisted_3 = { class: "bonus-name" }
const _hoisted_4 = { class: "d-flex flex-column gap-xs" }
const _hoisted_5 = { class: "bonus-description" }
const _hoisted_6 = { class: "d-flex flex-row gap-xs" }
const _hoisted_7 = { class: "bonus-amount" }

import SvgIcon from "@/components/SvgIcon.vue";
import {numberFormatter} from "@/service/NumberFormatter";
import WelcomeConfigDTO from "@/models/banners/WelcomeConfigDTO";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'Welcome',
  props: {
    config: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter();

const signUp = () => {
  router.push({name: 'login'})
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SvgIcon, {
          icon: "banners/badge",
          class: "d-flex"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('bonus.welcome.name')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('bonus.welcome.description')), 1),
        _createElementVNode("div", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(numberFormatter).formatNumber(_ctx.config.sum.amount)), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          onClick: _withModifiers(signUp, ["prevent"]),
          class: "btn btn-primary"
        }, _toDisplayString(_ctx.$t('sign_up')), 1)
      ])
    ])
  ]))
}
}

})